import SvgIcon from "@mui/material/SvgIcon";
const UserBlue = (props) => {
  return (
    <SvgIcon {...props}>
      <g
        id="Users_Blue"
        data-name="Users Blue"
        transform="translate(-0.25 -2.25)"
      >
        <path
          id="Path_1"
          data-name="Path 1"
          class="cls-1"
          d="M15,20.75a.75.75,0,0,1-.75-.75V19a6.25,6.25,0,0,0-12.5,0v1a.75.75,0,0,1-1.5,0V19a7.75,7.75,0,0,1,15.5,0v1A.75.75,0,0,1,15,20.75Z"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          class="cls-1"
          d="M23,15.25a.75.75,0,0,1-.75-.75V14a4.25,4.25,0,0,0-8.5,0,.75.75,0,0,1-1.5,0,5.75,5.75,0,0,1,11.5,0v.5A.75.75,0,0,1,23,15.25Z"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          class="cls-1"
          d="M8,12.75A4.75,4.75,0,1,1,12.75,8,4.755,4.755,0,0,1,8,12.75Zm0-8A3.25,3.25,0,1,0,11.25,8,3.254,3.254,0,0,0,8,4.75Z"
        />
        <path
          id="Path_4"
          data-name="Path 4"
          class="cls-1"
          d="M18,9.75A3.75,3.75,0,1,1,21.75,6,3.754,3.754,0,0,1,18,9.75Zm0-6A2.25,2.25,0,1,0,20.25,6,2.253,2.253,0,0,0,18,3.75Z"
        />
      </g>
    </SvgIcon>
  );
};
export default UserBlue;
